import DataSource from './DataSource';
import DataModel from './DataModel';

const DataAttributes = ['id', 'name', 'sex', 'breed_id',
  'country_id', 'pedigree', 'date_of_birth', 'color', 
  'titles', 'owner_name', 'owner_email', 'owner_phone', 
  'breeder_name', 'father_name', 'mother_name', 'registerTo',
  'request_id', 'need_catalog', 'dont_send_confirmation',
  ];

const Defaults = () => ({
  id: '',
  name: '',
  sex: '',
  breed_id: null,
  pedigree: '',
  date_of_birth: '',
  color: '',
  titles: '',
  owner_name: '',
  owner_email: '',
  owner_phone: '',
  breeder_name: '',
  father_name: '',
  mother_name: '',
  registerTo: [],
  need_catalog: false,
  dont_send_confirmation: false,
});

export default class Dog extends DataModel {
  static Defaults = Defaults;
  static DataAttributes = DataAttributes;
  static resource = DataSource.getSource('dogs', 'dogs{/:id}{/:action}.json', 'dog');

  constructor(data) {
    super(data);
    this.updateFrom({...this.constructor.Defaults(), ...data});
    if (this.date_of_birth) {
      this.date_of_birth = new Date(Date.parse(this.date_of_birth));
    } else {
      this.date_of_birth = null;
    }
  }
  
  
  send_registration_data(opts={}) {
    return this.constructor.resource.post({id: this.id, action: 'send_registration_data', ...opts});
  }

  reset_registration_data_sent(opts={}) {
    return this.constructor.resource.post({id: this.id, action: 'reset_ticket_sent', ...opts});
  }

}

